<template>
  <div class="container-dashboard">
      <div class="container-dashboard-content">
        <VuePerfectScrollbar class="sidebar-left" v-once>
            <div class="sidebar-left-header">
              Notification
            </div>
            <template  v-for="(notification, index) in notifications">
              <div class="sidebar-left-body" :key="index">
                <div class="sidebar-left-item sidebar-title">
                  {{ notification.title }}
                </div>
                <template v-for="(itemsNotification, indexNotification) in notification.data">
                  <a class="sidebar-left-item sidebar-content" href="javascript:void(0)" :key="indexNotification">
                    <div class="content-title">{{ itemsNotification.title }}</div>
                    <div class="content-date">{{ itemsNotification.date }}</div>
                  </a>
                </template>
              </div>
            </template>
        </VuePerfectScrollbar>
        <div  class="content">
          <div class="width-percent-50">
            <div class="card">
              <span>Coming soon</span>
            </div>
          </div>

          <div class="width-percent-50">
            <div class="card">
              <span>Coming soon</span>
            </div>
          </div>

          <div class="width-percent-50 pb-0">
            <div class="card">
              <span>Coming soon</span>
            </div>
          </div>

          <div class="width-percent-50 pb-0">
            <div class="card">
              <span>Coming soon</span>
            </div>
          </div>
        </div>
      </div>

<!--    <b-row>-->
<!--      <b-col sm="3">-->
<!--        <div class="box-dashboard">-->
<!--          <div class="title">Contract Draft <router-link :to="`/contract-client`" class="more pull-right">Manage</router-link></div>-->
<!--          <b-row>-->
<!--            <b-col sm="6">-->
<!--              <router-link :to="`/v2/contract-client`">-->
<!--                <div class="box-circle">2<br/>-->
<!--                  Client Contracts</div>-->
<!--              </router-link>-->
<!--            </b-col>-->
<!--            <b-col sm="6">-->
<!--              <router-link :to="`/v2/contract-supplier`">-->
<!--                <div class="box-circle">5<br/>-->
<!--                  Supplier Contracts</div>-->
<!--              </router-link>-->
<!--            </b-col>-->
<!--          </b-row>-->
<!--        </div>-->
<!--        <div class="box-dashboard">-->
<!--          <div class="title mb-0"> Master Settings-->
<!--            <router-link :to="`#`" class="more pull-right">Manage</router-link>-->
<!--          </div>-->
<!--        </div>-->
<!--      </b-col>-->
<!--      <b-col sm="6"> </b-col>-->
<!--      <b-col sm="3"> </b-col>-->
<!--    </b-row>-->
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    components: {
      VuePerfectScrollbar
    },
    data: function() {
      return {
        notifications: [
          {
            'title': 'Today 10.10.2019',
            'data': [
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 18:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 20:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 18:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 20:00'},
            ]
          },
          {
            'title': 'Today 10.11.2019',
            'data': [
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 18:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 20:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 18:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 20:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 18:00'},
              {'title':'Awais Bone completed job FCU-002.987','date':'Today, 20:00'},
            ]
          }
        ]
      }
    }
  }
</script>